import { useRef } from 'react';

import { useConnectAppsCooldown } from '../../ui/quick-find/textfield/connect-apps-icon/use-connect-apps-cooldown';

/**
 * Returns true when the 3P banner should be suppressed because the connect
 * apps pill animation is eligible to play this session. The value is captured
 * on first render so a mid-session cooldown exhaustion (e.g. the 10th play)
 * does not immediately surface the banner.
 */
export function useShouldSuppressBannerForAnimation(): boolean {
	const { canAnimate } = useConnectAppsCooldown();
	const suppressAtMount = useRef(canAnimate());
	return suppressAtMount.current;
}
